import React from 'react'
import { Layout } from "antd";
import './index.css'

const Footer = ({collapsed}) => {
  const FooterLayout = Layout.Footer;
  const currentYear = new Date().getFullYear();

  return (
    <>
    {(window.innerWidth > 760 ? true : collapsed) &&  
    <FooterLayout className="footer-container">
      <p className="footer-text">
        TouchSale Portal @ {currentYear} Powered by UnrealSoft
      </p>
    </FooterLayout>}
    </>

  );
}

export default Footer